import React from "react";
import MovimientoBase, { MovimientoBaseConfig } from "./MovimientoBase";

const config: MovimientoBaseConfig = {
  documentTitle: "Stock - Ajustes negativos | Saas",
  breadcrumbTitle: "Ajustes negativos",
  breadcrumbSection: "Stock",
  conceptoTitulo: "Ajuste negativo",
  conceptoValor: "Ajuste negativo",
  mostrarSeccionPersona: false,
  motivoOpciones: [
    { value: "merma", label: "Merma / deterioro" },
    { value: "rotura", label: "Rotura en traslado" },
    { value: "vencimiento", label: "Vencimiento" },
    { value: "ajuste_manual", label: "Ajuste manual" },
  ],
  motivoTipo: "ajuste_negativo",
  apiPath: "/api/stock/ajustes/negativos",
};

const AjustesNegativosPage: React.FC = () => <MovimientoBase config={config} />;

export default AjustesNegativosPage;
